import {TranslatePipe} from '@ngx-translate/core';
import {Slide} from '@app/common/interfaces/slide';
import {ToursComponent} from '../tours/tours.component';
import {Component, inject, OnInit, Renderer2} from '@angular/core';
import {AppStateService} from "@app/common/services/app-state.service";
import {ContactComponent, FaqComponent, HeaderComponent, SliderComponent, VideoComponent} from '@app/common/ui-kits';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  imports: [
    SliderComponent,
    HeaderComponent,
    TranslatePipe,
    ToursComponent,
    FaqComponent,
    VideoComponent,
    ContactComponent
  ]
})
export class HomeComponent implements OnInit {
  private readonly renderer = inject(Renderer2);
  private readonly appStateService = inject(AppStateService);

  public homePageSlides: Slide[] = [
    {
      url: '../../../../assets/img/slider/slider1.jpg',
      title: 'Discover',
      subTitle: 'New Adventure',
      description: 'Armenia is a state in the Caucasus'
    },
    {
      url: '../../../../assets/img/slider/slider2.jpg',
      title: 'Discover',
      subTitle: 'New Trip',
      description: 'Armenia is a state in the Caucasus'
    },
    {
      url: '../../../../assets/img/slider/slider3.jpg',
      title: 'Discover',
      subTitle: 'New Experience',
      description: 'Armenia is a state in the Caucasus'
    },
    {
      url: '../../../../assets/img/slider/slider4.jpg',
      title: 'Discover',
      subTitle: 'New Experience',
      description: 'Armenia is a state in the Caucasus'
    }
  ];

  constructor() {
  }

  ngOnInit() {
    this.appStateService.setPageSeo('home', this.renderer);
  }

}
